import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  isServer(): boolean {
    return isPlatformServer(this.platformId);
  }

  redirect(url: string) {
    if (this.isBrowser()) {
      window.location.href = url;
    } else {
      console.log('Redirection not implemented for SSR');
    }
  }

  redirectToTopUrl() {
    const path = window.location.href;
    const url = this.getFirstTwoSegments(path);
    this.redirect(url);
  }

  reload() {
    if (this.isBrowser()) {
      window.location.reload();
    } else {
      console.log('Reload not implemented for SSR');
    }
  }

  url(): string | undefined {
    if (this.isBrowser()) {
      return window.location.href;
    } else {
      console.log('URL not implemented for SSR');
      return undefined;
    }
  }

  private getFirstTwoSegments(url: string) {
    const urlObj = new URL(url);
    const path = urlObj.pathname;
    const segments = path.split('/').filter(segment => segment !== '');
    const firstTwoSegments = segments.slice(0, 2);
    return `/${firstTwoSegments.join('/')}`;
  }
}
